/**
 * @private
 */
export const OperationType = {
  Create: 'create',
  Read: 'read',
  ReadById: 'readById',
  Update: 'update',
  Delete: 'delete',
  DeleteById: 'deleteById',
  Count: 'count',
  Clear: 'clear',
  Group: 'group'
};



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/operations/operation-type.js